<template>
	<div>
		<div class="header">
			<div
				style="
					display: flex;
					justify-content: space-between;
					align-items: center;
				"
			>
				<div style="display: flex">
					<div class="backIcon">
						<i class="cubeic-back"></i>
					</div>
					<div
						style="
							font-size: 20px;
							color: white;
							font-weight: bold;
							display: flex;
							justify-content: center;
							margin-left: 10px;
							align-items: center;
							height: 35px;
						"
					>
						师兄芋圆
					</div>
				</div>
				<div
					style="
						font-size: 13px;
						margin-right: 30px;
						color: white;
						font-weight: 100;
					"
				>
					外送路程: 10 km
				</div>
			</div>
			<div style="width: 100vw; display: flex; justify-content: center">
				<cube-select
					v-model="value"
					:options="options"
					class="selectStyle"
				></cube-select>
			</div>
		</div>
		<div
			class="content"
			style="max-height: 90vh; overflow-y: scroll; padding: 100px 35px 120px"
		>
			<div class="card" style="border: 1px solid red">
				<div
					style="
						color: #07111b;
						font-size: 13px;
						font-weight: bold;
						display: flex;
						justify-content: space-between;
						align-items: center;
					"
				>
					<div>
						送餐地址
						<span style="color: red">(必填)</span>
					</div>
					<div @click="showAddressDialog">
						<span>選擇</span>
					</div>
				</div>
				<div style="border: 1px solid #07111b; margin: 10px 0px"></div>
				<div style="font-size: 14px; color: #646464; padding: 15px 20px">
					<span>送餐地址</span>
					<span style="margin-left: 20px">台中市西區忠誠街58號</span>
				</div>
			</div>
			<div class="card">
				<div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						color: #07111b;
					"
				>
					<div style="color: #07111b; font-size: 13px; font-weight: bold">
						訂單金額
					</div>
					<div style="font-size: 18px; font-weight: bold">$ 170</div>
				</div>
				<div style="border: 1px solid #07111b; margin: 10px 0px"></div>
				<div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						color: #646464;
						margin: 10px 0px;
					"
				>
					<div style="font-size: 12px">商品金額</div>
					<div style="font-size: 12px">$ 185</div>
				</div>
				<div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						color: #646464;
						margin: 10px 0px;
					"
				>
					<div style="font-size: 12px">折扣</div>
					<div style="font-size: 12px">-$ 15</div>
				</div>
				<div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						color: #646464;
					"
				>
					<div style="font-size: 12px">
						發車費<i class="cubeic-question" style="margin-left: 10px"></i>
					</div>
					<div style="font-size: 13px">$ 50</div>
				</div>
			</div>
			<div class="card">
				<div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						color: #07111b;
					"
				>
					<div style="color: #07111b; font-size: 13px; font-weight: bold">
						付款方式
					</div>
					<div
						style="font-size: 13px; font-weight: bold"
						@click="showRechargeDialog"
					>
						更改
					</div>
				</div>
				<div style="border: 1px solid #07111b; margin: 10px 0px"></div>
				<div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						color: #646464;
						margin: 15px 0px;
					"
				>
					<div style="font-size: 12px">點數</div>
					<div style="font-size: 13px">
						尚有580點
						<div
							style="
								font-size: 12px;
								color: #00a0dc;
								margin-left: 10px;
								display: inline-block;
							"
							@click="showRechargeDialog"
						>
							充值
						</div>
					</div>
					<div style="font-size: 12px">$370</div>
				</div>
			</div>

			<div class="card">
				<div style="color: #07111b; font-size: 16px; font-weight: bold">
					若店家品項賣完<span style="color: red"> (必填)</span>
				</div>
				<div style="color: #646464; font-size: 13px">
					<cube-checkbox-group
						v-model="checkList"
						style="background-color: transparent; margin-top: 10px"
					>
						<cube-checkbox option="1">移除此品項</cube-checkbox>
						<cube-checkbox option="2"
							>刪除整筆訂單<span style="color: red"
								>(須負擔發車費用$50)</span
							></cube-checkbox
						>
						<cube-checkbox option="3">請通知我</cube-checkbox>
					</cube-checkbox-group>
				</div>
				<div style="border: 1px solid #07111b; margin: 10px 0px"></div>
				<div
					style="
						color: #07111b;
						font-size: 16px;
						font-weight: bold;
						margin-top: 15px;
					"
				>
					若現場品項價格有異<span style="color: red"> (必填)</span>
				</div>
				<div style="color: #646464; font-size: 13px">
					<cube-checkbox-group
						v-model="checkList2"
						style="background-color: transparent; margin-top: 10px"
					>
						<cube-checkbox option="1"
							>直接調整成店家實際價格並購買</cube-checkbox
						>
						<cube-checkbox option="2">移除此品項</cube-checkbox>
						<cube-checkbox option="3"
							>刪除整筆訂單<span style="color: red"
								>(須負擔發車費用$50)</span
							></cube-checkbox
						>
						<cube-checkbox option="4">請通知我</cube-checkbox>
					</cube-checkbox-group>
				</div>
			</div>
			<div
				style="
					color: #07111b;
					font-size: 15px;
					margin-bottom: 10px;
					font-weight: bold;
				"
			>
				<div>統一編號 (提供您報帳需求)</div>
			</div>
			<div>
				<cube-input
					class="inlineCard"
					v-model="code"
					placeholder="輸入"
				></cube-input>
			</div>
		</div>
		<div class="footer">
			<div
				style="
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin: 15px 20px;
					font-size: 15px;
					color: #07111b;
				"
			>
				<div>10 km</div>
				<div>運費 $ 150</div>
			</div>
			<div class="btnConfirm">
				<div style="font-size: 17px">約 40 分</div>
				<div style="font-size: 17px; font-weight: bold">送出訂單</div>
				<div style="font-size: 17px">$ 370</div>
			</div>
		</div>
		<!-- address dialog -->
		<div class="overlay" :class="{ showOverlay: showAddress }"></div>
		<div class="detail" :class="{ showOverlay: showAddress }">
			<shopAddressDialog></shopAddressDialog>
		</div>
		<!-- end address dialog -->

		<!-- Recharge dialog -->
		<div class="overlay" :class="{ showOverlay: showRecharge }"></div>
		<div class="detail" :class="{ showOverlay: showRecharge }">
			<shopRechargeDialog></shopRechargeDialog>
		</div>
		<!-- end Recharge dialog -->
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import shopAddressDialog from "./common/shop-address-dialog.vue";
import shopRechargeDialog from "./common/shop-recharge-dialog.vue";

export default {
	components: {
		shopAddressDialog,
		shopRechargeDialog,
	},
	data() {
		return {
			options: ["十分鐘後", "一小時後", "兩小時後", "立即出發"],
			value: "立即出發",
			editValue: false,
			code: "",
			checkList: [],
			checkList2: [],
		};
	},
	computed: {
		...mapState({
			showAddress: (state) => state.goodsdetail.showAddress,
			showRecharge: (state) => state.goodsdetail.showRecharge,
		}),
	},
	methods: {
		...mapActions({
			setAddress: "setAddress",
			setRecharge: "setRecharge",
		}),
		showAddressDialog() {
			this.setAddress(true);
		},
		showRechargeDialog() {
			this.setRecharge(true);
		},
	},
};
</script>

<style scoped>
.header {
	position: fixed;
	top: 0px;
	width: 100%;
	height: 65px;
	background-color: #2c3b53;
	box-shadow: 0px 2px 8px 2px darkgrey;
	padding: 12px 15px;
	z-index: 2;
}
.footer {
	position: fixed;
	bottom: 0;
	width: 100%;
	height: 100px;
	background-color: #ffffff;
	box-shadow: 0 4px 10px 5px darkgrey;
	z-index: 2;
}
.btnConfirm {
	margin: 15px;
	display: flex;
	justify-content: space-between;
	background-color: #2c3b53;
	border-radius: 8px;
	color: white;
	align-items: center;
	padding: 13px 20px;
	box-shadow: 0px 1px 8px darkgrey;
}
.backIcon {
	background: white;
	width: 30px;
	height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	font-size: 18px;
}
.selectStyle {
	height: 30px;
	border-radius: 8px;
	border: none;
	width: 100px;
	border: 1px solid black;
	display: flex;
	justify-content: center;
	align-items: center;
}
.card {
	margin: 20px -20px;
	border: 1px solid darkgray;
	box-shadow: 0px 1px 8px rgb(8, 6, 6);
	padding: 15px;
	border-radius: 10px;
}
.inlineCard {
	font-size: 12px;
	line-height: 16px;
	color: #b0aeae;
	border: 2px solid #e1e1e1;
	border-radius: 6px;
}
.inlineCard >>> .cube-textarea {
	background-color: transparent !important;
}
.listStyle {
	display: flex;
	justify-content: space-between;
	margin: 20px 0px;
	border-bottom: 1px solid darkgray;
	padding-bottom: 15px;
	align-items: center;
	color: #646464;
}
</style>

<style scoped>
.overlay {
	position: fixed;
	display: none;
	width: 100vw;
	height: 100vh;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 2;
	cursor: pointer;
}
.detail {
	z-index: 3;
	height: 60vh;
	display: none;
	bottom: 0;
	background: white;
	left: 0px;
	position: fixed;
	right: 0;
}
.showOverlay {
	display: block;
}
</style>
